import { c as _c } from "react/compiler-runtime";
import InputCheckbox from '@components/input-checkbox/InputCheckbox';
import Switch from '@components/switch/Switch';
import arrowDownIcon from '@images/svg/index/arrow-down.svg';
import ROUTES from '@lib/constants/routes';
import { handleChangeFormName, handleOpenModelForm } from '@lib/store/slices/ComponentsSlice';
import cn from 'classnames';
import { useRouter } from 'next/navigation';
import { useRef, useState } from 'react';
import SVG from 'react-inlinesvg';
import { useDispatch } from 'react-redux';
import NumberSliderEqualizer from '../slider-calculator/NumberSliderEqualizer';
import styles from './CardCalculator.module.scss';
export const handleCalculatePercent = (value, maxFirstPayment) => {
  return Math.floor(value * 100 / maxFirstPayment);
};
export const CardCalculator = t0 => {
  const $ = _c(88);
  const {
    isMobile,
    selectedBenefit,
    creditTerm,
    firstPayment,
    minFirstPayment: t1,
    isMinFirstPayment,
    isPercentageAmount,
    handleOnChangeSlider,
    onChangeFirstPayment,
    handleChangeCreditTerm,
    onChangeCredit,
    setIsPercentageAmount,
    setIsMinFirstPayment,
    setPayment,
    programTypes,
    setProgramTypes
  } = t0;
  const minFirstPayment = t1 === undefined ? 0 : t1;
  const dispatch = useDispatch();
  const router = useRouter();
  const dropdownRef = useRef(null);
  const [isProgramsShown, setIsProgramsShown] = useState(false);
  let t2;
  if ($[0] !== creditTerm || $[1] !== firstPayment) {
    t2 = {
      creditTerm,
      firstPayment
    };
    $[0] = creditTerm;
    $[1] = firstPayment;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [updateSlider, setUpdateSlider] = useState(t2);
  const {
    maxPeriod,
    minPeriod,
    maxPrice
  } = selectedBenefit.mortgage;
  const maxFirstPayment = selectedBenefit?.benefitPrice;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (slider, values) => {
      setUpdateSlider(prev => ({
        ...prev,
        [slider]: Number(values[0])
      }));
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onUpdateSlider = t3;
  let t4;
  if ($[4] !== setProgramTypes) {
    t4 = value => {
      setProgramTypes(prevProgramTypes => prevProgramTypes.map(item => ({
        ...item,
        active: item.value === value.value
      })));
    };
    $[4] = setProgramTypes;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onUpdateMenu = t4;
  let t5;
  if ($[6] !== programTypes) {
    t5 = programTypes?.find(_temp);
    $[6] = programTypes;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const activeItem = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className={styles.modal__text}>Выберите программу</p>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsProgramsShown(_temp2);
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = activeItem?.label;
  let t9;
  if ($[10] !== t8) {
    t9 = <span>{t8}</span>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = isProgramsShown && styles.equalizer_svgRotate;
  let t11;
  if ($[12] !== t10) {
    t11 = cn(styles.equalizer_svgArrows, t10);
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <span><SVG src={arrowDownIcon.src} alt="" fill="#ffffff" className={t11} /></span>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t9) {
    t13 = <p className={styles.equalizer_chosedProgram}>{t9}{t12}</p>;
    $[16] = t12;
    $[17] = t9;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== isProgramsShown || $[20] !== onUpdateMenu || $[21] !== programTypes) {
    t14 = isProgramsShown && <div className={styles.equalizer_programs}>{programTypes?.map(p => <div key={p.value} className={cn(styles.equalizer_programs_item, p.active ? styles.equalizer_program_active : "")} onClick={() => onUpdateMenu(p)}>{p.label}</div>)}</div>;
    $[19] = isProgramsShown;
    $[20] = onUpdateMenu;
    $[21] = programTypes;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14) {
    t15 = <div className={styles.dropdown_block}>{t6}<div ref={dropdownRef} className={styles.equalizer_dropdown} onClick={t7}>{t13}{t14}</div></div>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className={styles.modal__text}>Первоначальный взнос</div>;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== maxFirstPayment || $[28] !== updateSlider.firstPayment) {
    t17 = handleCalculatePercent(Number(updateSlider.firstPayment), maxFirstPayment).toString();
    $[27] = maxFirstPayment;
    $[28] = updateSlider.firstPayment;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = minFirstPayment || 0;
  const t19 = maxFirstPayment || 10;
  const t20 = firstPayment || 0;
  let t21;
  if ($[30] !== handleOnChangeSlider) {
    t21 = (_slider, values_0) => {
      handleOnChangeSlider(values_0[0]);
    };
    $[30] = handleOnChangeSlider;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  const t22 = maxFirstPayment - maxPrice || 10;
  let t23;
  if ($[32] !== t22) {
    t23 = [0, t22];
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== isPercentageAmount || $[35] !== maxPrice || $[36] !== onChangeFirstPayment || $[37] !== t17 || $[38] !== t18 || $[39] !== t19 || $[40] !== t20 || $[41] !== t21 || $[42] !== t23 || $[43] !== updateSlider.firstPayment) {
    t24 = <NumberSliderEqualizer percent={t17} switchPercent={isPercentageAmount} maxAllowedValue={maxPrice} min={t18} max={t19} start={t20} step={1} slider="firstPayment" textValue={updateSlider.firstPayment} onChange={onChangeFirstPayment} onChangeSlider={t21} withPercent={true} onUpdateSlider={onUpdateSlider} paddingSlider={t23} />;
    $[34] = isPercentageAmount;
    $[35] = maxPrice;
    $[36] = onChangeFirstPayment;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
    $[41] = t21;
    $[42] = t23;
    $[43] = updateSlider.firstPayment;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== selectedBenefit.mortgage.differenceBetweenPrice) {
    t25 = selectedBenefit.mortgage.differenceBetweenPrice !== 0 && <div className={`${styles.modal__text} ${styles.modal__text_grey}`}>Увеличьте первый взнос и получите скидку на квартиру</div>;
    $[45] = selectedBenefit.mortgage.differenceBetweenPrice;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t24 || $[48] !== t25) {
    t26 = <div className={styles.slider}>{t16}{t24}{t25}</div>;
    $[47] = t24;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className={styles.modal__text}>Срок кредита, лет</div>;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  const t28 = minPeriod || 0;
  const t29 = maxPeriod || 10;
  const t30 = creditTerm || 0;
  const t31 = Number(updateSlider.creditTerm);
  let t32;
  if ($[51] !== handleChangeCreditTerm) {
    t32 = (_slider_0, values_1) => handleChangeCreditTerm(values_1[0]);
    $[51] = handleChangeCreditTerm;
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  let t33;
  if ($[53] !== onChangeCredit || $[54] !== t28 || $[55] !== t29 || $[56] !== t30 || $[57] !== t31 || $[58] !== t32) {
    t33 = <div className={styles.slider}>{t27}<NumberSliderEqualizer withPercent={false} min={t28} max={t29} start={t30} step={1} slider="creditTerm" textValue={t31} onChange={onChangeCredit} onChangeSlider={t32} onUpdateSlider={onUpdateSlider} /></div>;
    $[53] = onChangeCredit;
    $[54] = t28;
    $[55] = t29;
    $[56] = t30;
    $[57] = t31;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== isPercentageAmount || $[61] !== setIsPercentageAmount) {
    t34 = <InputCheckbox className={styles.checkbox} valid={true} labelText={"\u0421\u0443\u043C\u043C\u0430 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0432\u0437\u043D\u043E\u0441\u0430 \u0432 %"} id="firstPaymentIsPercent" name="firstPaymentIsPercent" onClick={() => setIsPercentageAmount(!isPercentageAmount)} />;
    $[60] = isPercentageAmount;
    $[61] = setIsPercentageAmount;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== isMinFirstPayment || $[64] !== selectedBenefit.mortgage.minPrice || $[65] !== setIsMinFirstPayment || $[66] !== setPayment) {
    t35 = () => {
      if (!isMinFirstPayment) {
        setPayment(selectedBenefit?.mortgage?.minPrice);
      }
      setIsMinFirstPayment(!isMinFirstPayment);
    };
    $[63] = isMinFirstPayment;
    $[64] = selectedBenefit.mortgage.minPrice;
    $[65] = setIsMinFirstPayment;
    $[66] = setPayment;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] !== isMinFirstPayment || $[69] !== t35) {
    t36 = <InputCheckbox className={styles.checkbox} valid={true} checked={isMinFirstPayment} labelText={"\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0435\u0440\u0432\u044B\u0439 \u0432\u0437\u043D\u043E\u0441"} id="setMinFirstPayment" name="setMinFirstPayment" onClick={t35} />;
    $[68] = isMinFirstPayment;
    $[69] = t35;
    $[70] = t36;
  } else {
    t36 = $[70];
  }
  let t37;
  if ($[71] !== t34 || $[72] !== t36) {
    t37 = <div className={styles.checkboxes}>{t34}{t36}</div>;
    $[71] = t34;
    $[72] = t36;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] !== dispatch || $[75] !== isMobile) {
    t38 = !isMobile && <><Switch handleSwitch={() => {
        dispatch(handleOpenModelForm(true));
        dispatch(handleChangeFormName("flatForm"));
      }} switchText={"\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"} testId="flatFormOpen" white={true} /></>;
    $[74] = dispatch;
    $[75] = isMobile;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== router) {
    t39 = <Switch switchText={"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E\u0431 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u043F\u043E\u043A\u0443\u043F\u043A\u0438"} handleSwitch={() => router.push(`${ROUTES.purchaseTerms.plainRoot}${ROUTES.purchaseTerms.mortgage}`)} transparent={true} someStyles={styles.mortgageLink} />;
    $[77] = router;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t38 || $[80] !== t39) {
    t40 = <div className={styles.block_btn}>{t38}{t39}</div>;
    $[79] = t38;
    $[80] = t39;
    $[81] = t40;
  } else {
    t40 = $[81];
  }
  let t41;
  if ($[82] !== t15 || $[83] !== t26 || $[84] !== t33 || $[85] !== t37 || $[86] !== t40) {
    t41 = <div className={styles.modal__left}><div className={styles.sliders}>{t15}{t26}{t33}{t37}{t40}</div></div>;
    $[82] = t15;
    $[83] = t26;
    $[84] = t33;
    $[85] = t37;
    $[86] = t40;
    $[87] = t41;
  } else {
    t41 = $[87];
  }
  return t41;
};
function _temp(item_0) {
  return item_0?.active;
}
function _temp2(prev_0) {
  return !prev_0;
}